<template>
  <div class="head-background" :style="{ backgroundImage: `url(${headerBackground})` }">
    <div id="header-website">
      <v-app-bar
        fixed class="appbar-header"
        style="background: transparent; margin: 0 auto; padding-top:15px; height: fit-content !important;" v-model="appbar" dark>
        <div :style="{ backgroundImage: `url(${logo_background})` }" class="logo-prime"></div>
        <v-spacer></v-spacer>
        <div class="main-menu d-none d-md-block">
          <span v-for="(menuItem, index) in menu" :key="index">
            <v-btn :to="menuItem.to" v-if="menuItem.children.length == 0" @click="editContent(menuItem.name)" text>  {{ $vuetify.lang.t('$vuetify.'+menuItem.name) }}</v-btn>
            <v-menu rounded="0" v-else dark offset-y open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :to="menuItem.to"
                  text
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="editContent(menuItem.name)"
                >
                  {{ $vuetify.lang.t('$vuetify.'+menuItem.name) }}
                </v-btn>
              </template>

              <v-list class="dropdown-menu">
                <v-list-item
                  v-for="(childItem, indexChild) in menuItem.children"
                  :key="indexChild"
                  :to="childItem.path"
                >
                  <v-list-item-title @click="editContent(childItem.name)">{{ $vuetify.lang.t('$vuetify.'+childItem.name) }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </span>
        </div>
        <v-spacer class="d-none d-md-block"></v-spacer>
        <div class="langs d-none d-md-block">
          <img :src="currentLang.flag" width="28px" style="vertical-align: middle;" />
          <v-menu rounded="0" dark offset-y open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                :ripple="false"
                class="lang-selector"
                
              >
                {{currentLang.title}}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list class="dropdown-menu">
              <v-list-item
                v-for="(lang,key) in langs"
                v-bind:key="key"
                @click="changeLang(lang)"
              >
                <v-list-item-title>{{lang.title}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-btn tile class="customer-login elevation-0 d-none d-md-flex" to="/contact">Contact</v-btn>
        
        
        <v-menu
          top
          :close-on-click="true"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :style="{ color: 'black' }"
              class="mr-3 elevation-0 d-md-none"
              dark
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <div v-for="(menuItem, index) in menu" :key="'child-'+index">
              <v-list-item v-if="menuItem.children.length == 0"><v-btn style="width: 100%" tile :to="menuItem.to" text> {{ $vuetify.lang.t('$vuetify.'+menuItem.name) }} </v-btn></v-list-item>
              
              <v-list-group
                v-else
                :ripple="false"
              >
                <template v-slot:activator>
                  <v-list-item-title :ripple="false"><v-btn class="before-opacity-0" :ripple="false" style="width: 100%" tile text>{{ $vuetify.lang.t('$vuetify.'+menuItem.name) }}</v-btn></v-list-item-title>
                </template>
                <div>
                  <v-list-item
                    v-for="(childItem, indexChild) in menuItem.children"
                    :key="indexChild"
                  >
                    <v-list-item-title><v-btn :to="childItem.path" style="width: 100%" tile text>{{ $vuetify.lang.t('$vuetify.'+childItem.name) }}</v-btn></v-list-item-title>
                  </v-list-item>
                </div>
              </v-list-group>
            </div>
            <v-list-item><v-btn style="width: 100%" tile :to="'/contact'" text>Contact</v-btn></v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>
    </div>
    <v-container style="background: linear-gradient(200deg, rgba(20, 77, 128, 0.84), rgb(36 116 180 / 0%));" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="10" offset-md="2">
          <v-card style="margin-top:120px; height:25%; background: transparent; text-align:left;" dark flat>
            <span class="headline-index text-h3 text-md-h2 text-lg-h1 mb-1 mb-1" @click="editContent('pages.'+page_title+'.title')">{{ $vuetify.lang.t('$vuetify.pages.'+page_title+'.title') }}</span>
            <span class="back-head mb-1">Prime Shipping Agency</span>
            <p class="text-caption" v-if="!hidden" @click="editContent('pages.'+page_title+'.description')">{{ $vuetify.lang.t('$vuetify.pages.'+page_title+'.description') }}</p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
      
  </div>
</template>
<script>
import header_background from "../../../assets/background-about.png"
import logo_dark from "../../../assets/logo_dark.png"
import fr_logo from "../../../assets/france.png"
import en_logo from "../../../assets/uk.png"
import {loadLanguageAsync} from '../../../plugins/i18n'
import VueJwtDecode from "vue-jwt-decode"
export default {
  name: 'header_index',
  props: ['page_title', 'hidden', "onTop"],
  data: () => ({
      appbar: true,
      items: ['Track By', 'BL N°', 'Cont.N°', 'Avis.N°'],
      item: 'Track By',
      headerBackground: header_background,
      logo_background: logo_dark,
      menu: [
        { name: 'menu.homepage' , to:'/', children: []},
        { name:'menu.about', to:'/about', children: []},
        { name:'menu.gallery', to:'/gallery', children: []},
        { name:'menu.service', to:'/services', children: [
          { name: 'menu.ship_freight', path: '/services/ship-freight' },
          { name: 'menu.sea_freight', path: '/services/sea-freight' },
          { name: 'menu.air_freight', path: '/services/air-freight' },
          { name: 'menu.road_freight', path: '/services/road-freight' },
        ]},
        { name:'menu.quotation', to:'/request-quotation', children: []},
        { name:'menu.faq', to:'/faq', children: []},
        /*{ name:'menu.contact', to:'/contact', children: []},*/
      ],
      langs: [
        {title: 'Français', code: 'fr', flag: fr_logo},
        {title: 'English', code: 'en', flag: en_logo},
      ],
      currentLang: {
        flag: fr_logo,
        title: 'Français'
      },
      connected: false,
      connectedCustomer: {}
  }),
  mounted(){
    var lang_cookie = this.langs.find(lang => lang.code === this.$cookies.get('lang', lang.code))
    this.currentLang.flag = lang_cookie.flag
    this.currentLang.title = lang_cookie.title
    if(VueJwtDecode.decode(this.$store.getters.getCustomer)){
      this.connectedCustomer = VueJwtDecode.decode(this.$store.getters.getCustomer).customerData
      this.connected = true
    }else{
      this.connected = false
    }
  },
  methods: {
    changeLang(lang){
      if(lang.code === 'fr' || lang.code === 'en'){
        loadLanguageAsync(lang.code).then(() => {})
        this.$cookies.set('lang', lang.code)
        var index = this.langs.indexOf(lang)
        this.currentLang.flag = this.langs[index].flag
        this.currentLang.title = this.langs[index].title
      }
    },
    editContent(name){
      this.$emit('editContent', name)
    }
  }
  
}
</script>

<style lang="scss" scoped>
.customer-btn{
  border-radius: 0px !important;
}
.customer-dashboard{
  border-radius: 0px !important;
  background: transparent !important;
  color: black !important;
}
.menu-btn{
  border-radius: 0px !important;
  padding: 30px !important;
  margin-right: -15px;
  text-transform: none !important;
  margin-left: 35px;
  background: #000 !important;
  color: white !important;
}
@media (min-width: 960px) {
  .appbar-header{
    width:88%;
  }
}
@media (max-width: 959px) {
  .appbar-header{
     width:100%;
  }
}
.appbar-header{
  background: transparent !important; margin: 0 auto; padding-top:15px; height: fit-content !important;
}
.logo-prime{
  width: 128px;
  height: 60px;
  background-size: contain;
}
.lang-selector{
  color: black !important;
}
.lang-selector:before{
  position: relative;
  top: 2px;
  content: "";
  height: 1px;
  width: 22px;
  margin-left: 20px;
  background: #d9e2e0;
  left: -10px;
  opacity: 1;
}
.lang-selector:hover:before{
  opacity: 1;
}
.v-app-bar{
  background: white !important;
  padding:15px;
  box-shadow: 0 0 50px rgba(0,0,0,0.15) !important;
}
.v-app-bar .main-menu .v-btn{
    color: #4b4949 !important;
    font-size: 13px;
    margin-left:5px;
    font-weight: 700;
}
.customer-login{
  border-radius: 0px !important;
  padding: 30px !important;
  margin-right: -15px;
  text-transform: none !important;
  margin-left: 35px;
  background: linear-gradient(45deg, #05a4eb, #007eff);
  color: white !important;
}
.track-title{
    text-align: left;
    font-size: 16px;
    background: #e3e3e3;
    display: table;
    padding: 18px;
    margin: -68px;
    margin-left: -10px;
    text-transform: uppercase;
    color: #515151;
    font-weight: 700;

}
.back-head{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255,255,255,0.2);
  position: absolute;
  pointer-events: none;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
.head-background{
  /*background: url('https://demo.artureanec.com/html/transx/img/promo_2.jpg');*/
  background-size: cover; 
}
#header-website .v-btn{
  border-radius: 20px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headline-index {
  /*font-size: 64px !important;*/
  text-shadow: 0 0 20px rgba(0,0,0,0.6);
  font-weight: 700;
  text-transform: capitalize;
  /*line-height: 60px;*/
}
.text-caption{
  width:50%;
  text-align: left;
  /*margin: 0 auto;*/
  margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/website/commons/header.vue